/**
 * 即梦 2.1（jimeng_high_aes_general_v21_L）manifest
 * 数据来源：image.json field_map（旧模型，接口 disable: true）
 * 特点：无清晰度/质量分档；比例带真实像素；不支持参考图（field_map 无 ref_images / ref_type）
 */
import type { ImageModelConfig } from '../../types';

export const jimeng2_1: ImageModelConfig = {
  id: '01JVKEMQ9P393V1179MG0NHP94',
  displayName: '即梦 2.1',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1', width: 512, height: 512 },
      { label: '2:3', value: '2:3', width: 341, height: 512 },
      { label: '3:2', value: '3:2', width: 512, height: 341 },
      { label: '3:4', value: '3:4', width: 384, height: 512 },
      { label: '4:3', value: '4:3', width: 512, height: 384 },
      { label: '9:16', value: '9:16', width: 288, height: 512 },
      { label: '16:9', value: '16:9', width: 512, height: 288 },
      { label: '21:9', value: '21:9', width: 512, height: 219 },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  // 即梦2.1 不支持参考图（field_map 无 ref_images / ref_type）
  supportsReferenceImage: false,

  toggles: {},

  limits: {},
};
